import { render, staticRenderFns } from "./invitedCard.vue?vue&type=template&id=42f36c58&scoped=true&"
import script from "./invitedCard.vue?vue&type=script&lang=js&"
export * from "./invitedCard.vue?vue&type=script&lang=js&"
import style0 from "./invitedCard.vue?vue&type=style&index=0&id=42f36c58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f36c58",
  null
  
)

export default component.exports